import ENV from "config/Env";
import { backendQueryKey } from "hooks/useTypedQuery";

import type { CheckInService, CheckInServicePendingChecklist, Checklist, InterventionKeywordPendingChecklist, PinPendingChecklist } from "models";

const component = "PendingChecklistsDashboard";

export const PendingChecklistsQueryKeys = {
  checklists: backendQueryKey<Checklist[]>({ component, baseUrl: ENV.dealerBaseURL, endpoint: "/checklists/list" }),
  locationServices: backendQueryKey<CheckInService[]>({ component, baseUrl: ENV.appointmentBaseURL, endpoint: "/check_in/service/location_list" }),
  pinPendingChecklists: backendQueryKey<PinPendingChecklist[]>({ component, baseUrl: ENV.dealerBaseURL, endpoint: "/pin_pending_checklists/list" }),
  servicePendingChecklists: backendQueryKey<CheckInServicePendingChecklist[]>({ component, baseUrl: ENV.dealerBaseURL, endpoint: "/service_pending_checklists/list" }),
  interventionPendingChecklists: backendQueryKey<InterventionKeywordPendingChecklist[]>({
    component,
    baseUrl: ENV.dealerBaseURL,
    endpoint: "/intervention_keywords_pending_checklists/list"
  })
};
